import { FieldValues, get, useController, UseControllerProps } from "react-hook-form";
import { getDefaultErrorMessage } from "./FormErrorHelper";

export function useFormField<T extends FieldValues>(props: UseControllerProps<T>) {
    const {
        field,
        formState: { errors },
    } = useController(props);

    const error = get(errors, props.name);
    const errorMessage = error
        ? error.message?.length > 0
            ? error.message
            : getDefaultErrorMessage(error.type, props.rules)
        : undefined;

    const isRequired = !!props.rules?.required;

    return { field, errorMessage, isRequired };
}
